import React, { useCallback, FC, MouseEvent } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import makeStyles from '@mui/styles/makeStyles';
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Hidden from '@mui/material/Hidden'
import IconButton from '@mui/material/IconButton'

import nestedProperty from 'nested-property'

import MenuButton from '../widgets/MenuButton'
import authSelectors from '../../store/selectors/auth'
import projectSelectors from '../../store/selectors/project'
import projectActions from '../../store/modules/project'
import routerActions from '../../store/modules/router'
import networkActions from '../../store/modules/network'

import MoreVert from '@mui/icons-material/MoreVert'

import {
  ThunkDispatcher,
} from '../../types/store'

import {
  MenuButtonItem,
} from '../../types/app'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 140,
  },
  menuItemProjectSelector: {
    margin: theme.spacing(1),
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },
  smallMenuHolder: {
    paddingRight: theme.spacing(2),
    width: '100%',
    textAlign: 'right',
  }
}));

const ProjectSelector: FC<React.PropsWithChildren<unknown>> = ({

}) => {

  const classes = useStyles()
  const dispatch = useDispatch()
  const thunkDispatch = dispatch as ThunkDispatcher
  const user = useSelector(authSelectors.data)
  const projects = useSelector(projectSelectors.sortedProjects)
  const currentProjectId = useSelector(projectSelectors.currentProjectId)

  const HiddenAny = Hidden as any

  const onChangeEvent = useCallback(async (e: any) => {
    dispatch(networkActions.setGlobalLoading({
      active: true,
      message: 'switching projects...'
    }))
    await thunkDispatch(projectActions.setCurrentProject(e.target.value as string))
    dispatch(routerActions.navigateTo('dashboard'))
    setTimeout(() => {
      window.location.reload()
    }, 100)
  }, [])

  const onChangeProject = useCallback(async (menuItem: MenuButtonItem) => {
    if(!menuItem.meta || !menuItem.meta.id) return
    dispatch(networkActions.setGlobalLoading({
      active: true,
      message: 'switching projects...'
    }))
    await thunkDispatch(projectActions.setCurrentProject(menuItem.meta.id))
    dispatch(routerActions.navigateTo('dashboard'))
    setTimeout(() => {
      window.location.reload()
    }, 100)
  }, [])

  const getButton = useCallback((onClick: (e: MouseEvent) => void) => {
    return (
      <IconButton onClick={ onClick } size="large">
        <MoreVert color="primary" />
      </IconButton>
    );
  }, [])

  const getItems = useCallback(() => {
    return projects.map<MenuButtonItem>((project, i) => {
      const result: MenuButtonItem = {
        title: project.meta && project.meta.title ? project.meta.title : `project: ${project.id}`,
        meta: {
          id: project.id,
        },
      }
      return result
    })
  }, [
    projects,
  ])

  if(!user || !currentProjectId || projects.length <= 1) return null

  return (
    <>
      
      <HiddenAny smUp>
        <div className={ classes.smallMenuHolder }>
          <MenuButton
            getButton={ getButton }
            getItems={ getItems }
            onClick={ onChangeProject }
          />
        </div>
      </HiddenAny>

      <HiddenAny xsDown>
        <FormControl variant="standard" className={ classes.formControl }>
          <Select
            value={ currentProjectId }
            onChange={ onChangeEvent }
            MenuProps={{
              PaperProps: {
                style: {
                  border: '1px solid #d3d4d5',
                },
              },
            }}
          >
            {
              projects.map((project, i) => (
                <MenuItem
                  key={ project.id }
                  value={ project.id }
                >
                  { nestedProperty.get(project, 'meta.title') || 'project title' }
                </MenuItem>
              ))
            }
          </Select>
        </FormControl>
      </HiddenAny>
    </>
  )
}

export default ProjectSelector